export default __webpack_public_path__ + "files/media/hd-nyas.0cc0c7c9.jpg";